<template>
  <div class="form-group-simple"
  :class="{
    'form-group-simple--completed': !errors.has('policynumber'),
    'form-group-simple--error': errors.has('policynumber')}">

    <label for="PolicyNumber">{{ label }}</label>

    <input
      ref="input"
      type="text"
      v-model="policynumber"
      name="PolicyNumber"
      maxlength="15"
      placeholder="000001010"
      @blur="blur">

    <div class="form-group-simple__details">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error" v-show="errors.has('policynumber')">{{ errors.first('policynumber') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'

export default {
  name: 'v-input-policynumber-simple',
  props: {
    autofocus: {
      default: false,
      type: Boolean
    },
    label: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      policynumber: '',
      errors: ''
    }
  },
  created () {
    this.validator = new Validator()
    this.validator.attach('policynumber', 'required|numeric|min:1', { alias: 'Polisnummer' })
    this.$set(this, 'errors', this.validator.errors)
  },
  methods: {
    validate () {
      this.validator.validate('policynumber', this.policynumber)
    },
    blur () {
      this.validate()
    },
    setFocus () {
      this.$refs.input.focus()
    }
  },
  watch: {
    policynumber () {
      this.validate()
      this.$emit('updateValidation', !this.errors.has('policynumber'))
    }
  }
}
</script>
